import { useState } from "react";
import { createPortal } from "react-dom";
import PhotoAndDetailUploader from "./PhotoAndDetailUploader";

function ModalButton({ state }) {
    const [isOpen, setIsOpen] = useState(false);

    const modalContent = (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <PhotoAndDetailUploader
                    accidentVehicleCode={state.accidentVehicleCode}
                    vendorType={state.vendorType}
                    currentService={state.currentService}
                    onClose={() => setIsOpen(false)}
                />
            </div>
        </div>
    );

    return (
        <>
            <button
                className="bg-[#21A6E9] flex-1 justify-end py-2 px-4 w-full z-[20] rounded-full text-white font-satoshi font-medium text-[16px]"
                onClick={() => setIsOpen(true)}
            >
                {state.title}
            </button>

            {isOpen && createPortal(modalContent, document.body)}
        </>
    );
}

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    },
    modal: {
        backgroundColor: "white",
        padding: "20px",
        height: '90vh',
        borderRadius: "10px",
        textAlign: "center",
        margin: '1rem',
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY:'auto'
    },
};

export default ModalButton;
